import Styles from './Card.styles';

export const Card = ({ ...props }) => <Styles.Card {...props} />;
